
import moment from 'moment';
import React, { useContext } from 'react';
import count_days from '../functions/count_days';
import sum_amount from '../functions/sum_total_amount';
import sum_amount_by_payment_type from '../functions/sum_total_amount_by_payment_type';
import view_apartment_type_ar from '../functions/view_apartment_type';
import view_day_ar from '../functions/view_day_ar';
import FooterInvoice from '../bookings/invoice/FooterInvoice';
import HeaderInvoice from '../bookings/invoice/HeaderInvoice';
import { InvoiceContext } from '../bookings/invoice/Invoice_Context';
import '../bookings/payments/views/invoices/invoice.css';

function InvoiceUsersTracking()
{
    const data = useContext(InvoiceContext)
    return (
    <div className='col-md-12'>
        <div id="invoice" className="page-content fade-in-up" dir="rtl" style={{padding:"10px"}}>
            <div >
                <div className="invoice-header">
                    <div className="row">
                        <div className="col-12">
                            <HeaderInvoice title={
                                <>
                                 حـــركة المستخــدمين
                                <hr></hr>
                                {view_day_ar(data[0]?.date_payment)}
                                {" "+moment(data[0]?.date_payment).format("DD-MM-Y")}
                                </>
                            }/>
                        </div>
                    </div>
                </div>
                <table className="table table-bordered table-striped no-margin table-invoice" style={{fontSize:"16px"}}>
                        <thead className="color-view bg- ">
                            <tr >
                                <th style={{fontSize:"16px",width:"30%"}}>إجمالي  الحــركات</th>
                                <th style={{fontSize:"16px"}}>{data?.length}</th>
                            </tr>
                        </thead>
                </table>
                <div class="table-responsive">
                <table className="table table-bordered table-striped no-margin table-invoice">
                    <thead className="color-view bg- " >
                        <tr >
                            <th style={{fontSize:"12px",width:"10%"}}>التوقيت</th>
                            <th style={{fontSize:"12px"}}>المستخدم</th>
                            <th style={{fontSize:"12px"}}>البريد الإلكتروني</th>
                            <th style={{fontSize:"12px"}}>الحركة</th>
                            <th style={{fontSize:"12px"}}>تفاصيل الحركة</th>
                        </tr>
                    </thead>
                    <tbody style={{fontSize:"13px"}}>
                        {
                            data.map((item)=>{
                                return(
                                <>
                                <tr>
                                    <td dir='ltr'>
                                     {moment(item.date).format("hh:mm A")}
                                    </td>
                                    <td>{item.name} </td>
                                    <td>{item.username}</td>
                                    <td>{item.table_name}</td>
                                    <td>{item.details_tracking}</td>
                                </tr>
                                </>
                                );
                            })
                        }
                    </tbody>
                </table>
                </div>
            </div>
            <br></br>
            <table >
                <thead>
                    <th colSpan={5}>

                            <small style={{margin:"5px"}}>
                            تاريخ الطباعة
                        </small>
                        -
                        <small style={{margin:"5px"}} dir='rtl'>
                            {moment(new Date()).format("YYYY-MM-DD")}
                        </small>
                        -
                        <small style={{margin:"5px"}} dir='ltr'>
                            {moment(new Date()).format("LT")}
                        </small>
                    </th>
                </thead>
            </table>
            <FooterInvoice></FooterInvoice>
        </div>
    </div>
    );
}
export default InvoiceUsersTracking;